import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=27deee22&scoped=true&"
import script from "./Embed.vue?vue&type=script&lang=ts&"
export * from "./Embed.vue?vue&type=script&lang=ts&"
import style0 from "./Embed.vue?vue&type=style&index=0&id=27deee22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27deee22",
  null
  
)

export default component.exports